import client from "./client";

export const listEnquiries = (page = 1, limit = 20) =>
  client.post("/enquiry/list", { page, limit });

export const getEnquiry = (id) => client.post("/enquiry/get", { id });

export const deleteEnquiry = (id) => client.post("/enquiry/delete", { id });
